import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {AuthService} from 'src/app/services/auth/auth.service';
import {MediaObserver} from "@angular/flex-layout";
import {ClientaddressesService} from '../../services/apiclient/clientaddresses/clientaddresses.service';
import {MatDialogConfig, MatDialog} from '@angular/material/dialog';
import {MatSidenav} from '@angular/material/sidenav';
import {ClientaccountService} from '../../services/apiclient/clientaccount/clientaccount.service';
import {forkJoin} from 'rxjs';
import {ClientMerchantsService} from 'src/app/services/apiclient/clientmerchants/clientmerchants.service';
import {Router} from '@angular/router';
import {ToolsService} from 'src/app/services/tools/tools.service';
import {RequiredInformationsComponent} from '../dialogs/required-informations/required-informations.component';
import {AuthPageManageService} from 'src/app/services/manage/page-manage/auth-page-manage.service';
import {CssService} from "../../services/css-service";

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
})
export class MainComponent implements OnInit {

  @ViewChild('leftNav') leftNav: MatSidenav | any;
  @ViewChild('rightNav') rightNav: MatSidenav | any;

  // User (firebase)
  user$: any;

  // ClientAccount (Api)
  clientAccount$: any;

  // Client merchants options (Cashless, order ...)
  clientMerchantsOptions$: number[] | any;
  optionsLoader: boolean = true;

  loader: boolean = true;

  // Slide mode sidenav
  mode: string | any;

  // Ico menu responsive
  opened: boolean | any;

  // Selected page
  currPage: string = "dashboard";

  // Status message
  statusMessage$: any;

  // Right side nav data
  sideDataType: string | any;
  sideData: any;

  constructor(
    private auth: AuthService,
    private authPageManage: AuthPageManageService,
    private media: MediaObserver,
    private clientApi: ClientaccountService,
    private clientMerchantApi: ClientMerchantsService,
    private addressApi: ClientaddressesService,
    private router: Router,
    public cssService: CssService,
    private tools: ToolsService,
    private dialog: MatDialog,
    private authFb: AuthService
  ) {

    this.media.asObservable().subscribe(() => {
      this.getResp();
    });

  }

  @HostListener('window:click', ['$event'])
  onClick(event: any) {
    if (!this.user$) {
      this.authFb.logOut("auth/home");
    }

  }

  ngOnInit() {

    this.authPageManage.removeSmskey();

    // Client data (firebase)
    this.auth.getUser.subscribe(data => {
      this.user$ = data;

    });

    // Current client account (Behavior)
    this.clientApi.getCurrClientAccount().subscribe(client => {

      if (client) {
        this.clientAccount$ = client;
      }
    });

    // Side Data (Behavior)
    this.tools.getSideData.subscribe(sideData => {

      if (sideData) {
        this.sideDataType = sideData.type;
        this.sideData = sideData.data;
        this.openSideData();
      }

    });

    // Current page (Behavior)
    this.tools.getPageClient.subscribe(page => {
      if (page) {
        setTimeout(() => {
          this.currPage = page;
        });
      }
    });

    // Merchants options  (Api)
    this.clientMerchantApi.getClientMerchantsOptions().subscribe(options => {
      forkJoin(
        this.clientApi.getClientAccount(),
        this.addressApi.getClientAddresses()
      ).subscribe(([client, addresses]) => {

        this.clientAccount$ = client;

        this.clientMerchantsOptions$ = options;

        this.clientApi.setCurrClientAccount(client);

        // this.checkRequiredInfo(client, addresses);
        this.loader = false;
      });
    });
  }

  getResp(): void {
    if (this.media.isActive("lt-md")) {
      this.opened = false;
      this.mode = "over"
    } else {
      this.opened = true;
      this.mode = "side";
    }
  }

  changePage(where: string) {
    this.currPage = where;
    this.router.navigate(["home/" + where]);
    if (this.media.isActive("lt-md")) {
      this.leftNav.close();
    }
  }

  checkRequiredInfo(client: any, addresses: any[]) {
    if (!client.firstname || !client.lastname || !client.phone || addresses && addresses.length < 1) {
      this.openRequiredInfoAddress(addresses);
    }
  }

  openRequiredInfoAddress(addresses: any[]): void {
    const myConf = new MatDialogConfig();
    myConf.disableClose = true;
    myConf.data = {
      client: this.clientAccount$,
      addresses: addresses
    };
    this.media.isActive("xs") ? myConf.width = "100%" : myConf.width = "700px";
    const myDial = this.dialog.open(RequiredInformationsComponent, myConf);
    myDial.afterClosed().subscribe(data => {
      if (data) {
        this.clientApi.setCurrClientAccount(data.client);
        this.addressApi.setAddresses(data.addresses);
      }
    });
  }

  openSideData() {
    this.rightNav.open();
  }

  closeSideData($ev?: any) {
    this.tools.setSideData(null);
    this.rightNav.close();
  }

  checkOptions(optionId: number) {
    // 14: Order 15: Cashless 13: Fidelity  20:Booking
    return this.clientMerchantsOptions$.includes(optionId) ? true : false;
  }
}
